import appUrl from "../../utils/Constants/appUrl";
import { postData } from "../genaric/genaric-api";

export async function getTimeZones() {
    return postData(appUrl.helpers.timeZone);
}
